import cx from 'classnames';
import type { ChangeEventHandler, ReactNode } from 'react';
import { RadioBehaviour } from '../../utils/RadioBehaviour';
import styles from './styles.module.css';

export interface RadioProps {
  id: string;
  name: string;
  checked?: boolean;
  right?: boolean;
  children: NonNullable<ReactNode>;
  value: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

/** @deprecated use Radio from kitt-universal instead */
export function Radio({ id, onChange, children, checked, name, value, right }: RadioProps): ReactNode {
  return (
    <RadioBehaviour
      id={id}
      name={name}
      checked={checked}
      value={value}
      className={cx(styles.RadioContainer, {
        [styles.AlignRight]: right,
      })}
      onChange={onChange}
    >
      <div
        className={cx(styles.OuterRadio, {
          [styles.Checked]: checked,
        })}
      >
        <div
          className={cx({
            [styles.InnerRadio]: checked,
          })}
        />
      </div>
      <div className={styles.RadioLabel}>{children}</div>
    </RadioBehaviour>
  );
}
